<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/49shyc/cover.jpeg?1684514558397" alt="This image is the cover for the book Unparalleled Talisman God, Volume 5"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unparalleled Talisman God, Volume 5
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>"You can refine medicine, but you can quickly break through?" "One of my Spirit Convergence Talismans can increase my cultivation speed by ten or even a hundred times!"</strong> </p><p></p><p>"You know how to forge weapons, and forging a divine weapon that can slay stars? I have the Nine Heavens Thunder Rune. I can summon the thunder from the Nine Heavens Divine Thunder, turning thousands of kilometers into ashes with a single attack! " "Are you skilled in formations? Can you attack or defend?" I have tens of thousands of inscriptions, and the lives of others depend on me! "  Ten thousand years ago, the Nine Heavens Supreme Elder perished … </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dong FangXingYun, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d4386adc